import async from '~/components/async'

export const routes = {
  '/': 'home',
  '/analytics/': 'analytics',
  '/collections/': 'collections',
  '/collections/:collectionId/edit/': 'collection',
  '/collections/new/': 'collection',
  '/contacts/': 'contacts',
  '/discounts/': 'discounts',
  '/discounts/:discountId/edit/': 'discount',
  '/discounts/new/': 'discount',
  '/events/': 'events',
  '/events/:eventId/': 'event',
  '/integrations/': 'integrations',
  '/orders/': 'orders',
  '/orders/:orderId/': 'order',
  '/payment-methods/': 'paymentMethods',
  '/payment-methods/:shopPaymentMethodId/': 'paymentMethod',
  '/payment-methods/new/:paymentMethodId/': 'paymentMethod',
  '/products/': 'products',
  '/products/:productId/edit/': 'product',
  '/products/:productId/edit/:tabId/': 'product',
  '/products/new/': 'product',
  '/settings/': 'settings',
  '/shipping-methods/': 'shippingMethods',
  '/shipping-methods/:shopShippingMethodId/': 'shippingMethod',
  '/shipping-methods/new/:shippingMethodId/': 'shippingMethod',
  '/taxes/': 'taxes',
  '/taxes/:taxId/': 'tax',
  '/videos/': 'videos',
  '/videos/:videoId/': 'video',
  '/checkout-settings/': 'checkoutSettings',
  '/product-accesses/': 'productAccesses',
  '/validate/': 'validate',
  '/validate/:ticketId/': 'validate',
};

export default {
  login: async('login', () => import(/* webpackChunkName: "login" */'./login')),
  home: async('home', () => import(/* webpackChunkName: "home" */'./home')),
  products: async('products', () => import(/* webpackChunkName: "products" */'./products')),
  orders: async('orders', () => import(/* webpackChunkName: "orders" */'./orders')),
  analytics: async('analytics', () => import(/* webpackChunkName: "analytics" */'./analytics')),
  discounts: async('discounts', () => import(/* webpackChunkName: "discounts" */'./discounts')),
  contacts: async('contacts', () => import(/* webpackChunkName: "contacts" */'./contacts')),
  settings: async('settings', () => import(/* webpackChunkName: "settings" */'./settings')),
  events: async('events', () => import(/* webpackChunkName: "events" */'./events')),
  collections: async('collections', () => import(/* webpackChunkName: "collections" */'./collections')),
  checkoutSettings: async('checkoutSettings', () => import(/* webpackChunkName: "checkoutSettings" */'./checkout-settings')),
  paymentMethods: async('paymentMethods', () => import(/* webpackChunkName: "paymentMethods" */'./payment-methods')),
  shippingMethods: async('shippingMethods', () => import(/* webpackChunkName: "shippingMethods" */'./shipping-methods')),
  taxes: async('taxes', () => import(/* webpackChunkName: "taxes" */'./taxes')),
  tax: async('tax', () => import(/* webpackChunkName: "tax" */'./tax')),
  integrations: async('integrations', () => import(/* webpackChunkName: "integrations" */'./integrations')),
  product: async('product', () => import(/* webpackChunkName: "product" */'./product')),
  collection: async('collection', () => import(/* webpackChunkName: "collection" */'./collection')),
  discount: async('discount', () => import(/* webpackChunkName: "discount" */'./discount')),
  event: async('event', () => import(/* webpackChunkName: "event" */'./event')),
  order: async('order', () => import(/* webpackChunkName: "order" */'./order')),
  paymentMethod: async('paymentMethod', () => import(/* webpackChunkName: "paymentMethod" */'./payment-method')),
  shippingMethod: async('shippingMethod', () => import(/* webpackChunkName: "shippingMethod" */'./shipping-method')),
  videos: async('videos', () => import(/* webpackChunkName: "videos" */'./videos')),
  video: async('video', () => import(/* webpackChunkName: "video" */'./video')),
  productAccesses: async('productAccesses', () => import(/* webpackChunkName: "productAccesses" */'./product-accesses')),
  validate: async('validate', () => import(/* webpackChunkName: "validate" */'./validate')),
}
